export default {
    title: 'registration_scene_resend_title',
    resendEmail: 'registration_scene_resend_email',
    passwordsMustMatch: 'error_passwords_must_match',
};
